import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, ViewContainerRef, NgZone } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

import { DataSourceRequestState } from '@progress/kendo-data-query';
import { ISubscription } from 'rxjs/Subscription';

import { LaborItemService } from '@fs/services/labor-item';
import { AuthService } from '@services/auth.service';
import { CommonService } from '@shared/services/common';
import { LaborItemModel } from '@fs/models/price-book/labor-item.model';
import { TabOpenService } from '@services/tab-open.service';
import { FSliteTradeService } from '@fs/services/trades';
import { DataSharingLTE } from '@fs/services/data-sharing-lte';
import { CommonMethods } from '@services/common.method';
import { PriceModel, PriceBucketModel } from '@fs/models/price-book/price-book.model';
import { Tabs } from '@enums/tab.enum';
import { Constants } from '@shared/models/constants';
import { NotificationsService } from '@shared/services/notification';
import { SpinnerService } from 'src/app/shared/services/spinner.service';
import { customJS } from '@fs/services/customjs';
import { ProductItemType } from '@fs/enums/common-enums';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'labor-item-form',
  templateUrl: './labor-create.component.html',
  styleUrls: ['./labor-create.component.scss'],
  providers: [LaborItemService, CommonMethods]
})
export class LaborItemFormComponent implements OnInit, AfterViewInit {

  //#region Input/Output
  @ViewChild('PriceInformation') priceInformation: ElementRef;
  @ViewChild('ItemInformation') itemInformation: ElementRef;
  //#endregion

  //#region Variable Declarations
  private dataLoaderCount = 2;
  private subscriptions: ISubscription[] = [];
  private destroyTab: boolean = false;
  private isUnsavedTriggered: boolean = false;

  public itemInformationValid: boolean = true
  public priceInformationValid: boolean = true

  public createLaborItemForm: FormGroup;
  public laborDetailData: any;
  public initialData: any;
  public tabCounter: number;
  public cancelConfirmation: boolean = false;
  public selectedData: any = {};
  public categories = [];
  public inputParams: any;
  public formType = "New"
  public defaultLaborImage: string = Constants.DefaultImagePaths.Labour;
  public formatOptions: any = {
    style: 'currency',
    currency: ''
  };
  public state: DataSourceRequestState = {
    skip: 0,
    take: 50,
    sort: [{
      field: 'Description',
      dir: 'asc'
    }],
  };
  public qbVersion: string = "";
  public chkIsFreqUsed: string;
  public chkAllowPriceEd: string;
  public chkAllowDescEd: string;
  public chkIsTaxable: string;
  public productItemType = ProductItemType;
  overlay: boolean = false;
  protected readonly ngUnsubscribe$ = new Subject();
  //#endregion

  //#region Constructor
  constructor(
    private frmbuilder: FormBuilder,
    private laborItemService: LaborItemService,
    private toastr: NotificationsService,
    private tabOpen: TabOpenService,
    private httpCommon: CommonService,
    private commonMethods: CommonMethods,
    private fSliteTradeService: FSliteTradeService,
    private _elementRef: ElementRef,
    private dataSharing: DataSharingLTE,
    private auth: AuthService,
    private showspinner: SpinnerService,
    private viewContainerRef: ViewContainerRef,
    private zone: NgZone,
    private $elementRef: ElementRef) {
    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
    this.httpCommon.GetIntialData(this.auth.getCompanyId(), "PriceBookAccountingCodes,PriceBuckets")
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(
      response => {
        this.initialData = response;
      }
    )
    this.GetTrades();
    this.CreatelabrItemForm();
    let subscription = this.tabOpen.routeToParentEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter && response.event.split("|")[0] == "replaceTab" && response.event.split("|")[1] == "discard") {
        $(this._elementRef.nativeElement).find(".tabs__content__box").removeClass("dirty");
        this.CheckAndReplace();
        this.DestroySubscriptions();
      }
      else if (response.tabCounter == this.tabCounter && response.event.split("|")[0] == "replaceTab" && response.event.split("|")[1] == "save") {
        this.CreateLaborItem();
      }
    })
    this.subscriptions.push(subscription);

    let subscription1 = this.tabOpen.ConfirmDestroyTabEvent.subscribe(response => {
      if (response.tabCounter == this.tabCounter) {
        this.destroyTab = true;
        this.CreateLaborItem();
      }
    });
    this.subscriptions.push(subscription1);

    subscription = this.tabOpen.ChangeComponentEvent.subscribe(response => {
      if (response.removeSubscriptions != undefined) {
        if (response.removeSubscriptions) {
          this.DestroySubscriptions();
        }
      }
    })
    this.subscriptions.push(subscription);

    this.qbVersion = (this.auth.getCompanyQBType()).toLowerCase();
    //#region Generate random Ids for controls
    this.chkIsFreqUsed = "ChkFreqUsed_" + CommonMethods.GenerateRandomID();
    this.chkAllowPriceEd = "ChkAllPriceEd_" + CommonMethods.GenerateRandomID();
    this.chkAllowDescEd = "ChkAllDescEd_" + CommonMethods.GenerateRandomID();
    this.chkIsTaxable = "ChkIsTaxable" + CommonMethods.GenerateRandomID();
    //#endregion
  }
  //#endregion
  
  //#region Lifecycle Events
  ngOnInit() {
    $("#mainContainer").scrollTop(0)
    if (this.inputParams.ID == undefined) {
      this.CreatelabrItemForm();
      this.HideDataLoader();
    }
    else {
      this.GetLaborItemDetail();
      this.HideDataLoader();
    }
  }

  ngAfterViewInit() {
    this.commonMethods.ApplyMaxLengthForKendoNumericBox(16);
  }

  ngOnDestroy() {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
    this.DestroySubscriptions();
  }

  ngDoCheck() {
    if (!this.isUnsavedTriggered) {
      let isDirty = this.createLaborItemForm.dirty;
      if (isDirty) {
        this.isUnsavedTriggered = true;
        this.tabOpen.unsavedChangedDetected({ dirty: isDirty, Index: this.tabCounter });
      }
    }
  }

  ngChanges() {

  }
  //#endregion

  //#region Methods
  public CreateLaborItem() {
    if (this.createLaborItemForm.valid) {
      let submitModel: LaborItemModel = new LaborItemModel();

      submitModel.ID = this.createLaborItemForm.value.ID;
      submitModel.ItemNumber = this.createLaborItemForm.value.ItemNumber;
      submitModel.Description = this.createLaborItemForm.value.Description;
      submitModel.Cost = this.createLaborItemForm.value.Cost;
      submitModel.Note = this.createLaborItemForm.value.Note;
      submitModel.IsFrequentlyUsed = this.createLaborItemForm.value.IsFrequentlyUsed;
      submitModel.Category = { ID: this.createLaborItemForm.value.Category };

      if (this.laborDetailData.Prices.length > 0) {
        submitModel.Prices[0] = this.laborDetailData.Prices[0];
        submitModel.Prices[0].ID = this.laborDetailData.Prices[0].ID;
        submitModel.Prices[0].Amount = this.createLaborItemForm.value.StandardCost;
        submitModel.Prices[0].IsDirty = true;
      } else if (this.initialData.PriceBuckets.length > 0) {
        let priceBuckets = this.initialData.PriceBuckets.filter(x => x.Name == 'Standard');
        let price = new PriceModel();
        let priceBucket = new PriceBucketModel();
        price.Amount = this.createLaborItemForm.value.StandardCost;
        priceBucket.ID = priceBuckets != null ? priceBuckets[0].ID : "";
        price.Bucket = priceBucket;
        submitModel.Prices[0] = price;
      }
      if (this.createLaborItemForm.value.AccountingCode != "")
        submitModel.AccountingCode = { ID: this.createLaborItemForm.value.AccountingCode, Name: "", Description: "" };
      else submitModel.AccountingCode = null;
      submitModel.IsDiscountExcluded = false;// as every item must has to be discountable
      //this.createLaborItemForm.value.IsDiscountExcluded;
      submitModel.IsPriceEditAllowed = this.createLaborItemForm.value.IsPriceEditAllowed;
      submitModel.IsDescriptionEditAllowed = this.createLaborItemForm.value.IsDescriptionEditAllowed;
      submitModel.IsTaxable = this.createLaborItemForm.value.IsTaxable;
      submitModel.ModifyDate = this.laborDetailData.ModifyDate;
      submitModel.IsAgreementExcluded = this.createLaborItemForm.value.IsAgreementExcluded;
      this.showspinner.showloader(this.viewContainerRef, this.tabCounter, 0);
      if (!CommonMethods.CheckNullOrUndefined(submitModel.ID, true)) {
        this.laborItemService.EditLaborItem({ ID: submitModel.ID }, submitModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          response => {
            if ($(this._elementRef.nativeElement).find('.tabs__content__box').hasClass('dirty')) {
              $(this._elementRef.nativeElement).find('.tabs__content__box').removeClass('dirty');
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Labor item " + submitModel.ItemNumber + " updated", "Success!");
            this.dataSharing.ItemChangeEvent();
            setTimeout(() => {
              if (this.destroyTab) {
                this.tabOpen.DestroyTab(this.tabCounter);
              }
              else {
                this.tabOpen.ReplaceTab(
                  {
                    CurrentTabIndex: this.tabCounter,
                    newTabInfo: {
                      tabId: Tabs.FsLiteLaborItemDetail,
                      params: { ID: submitModel.ID },
                      tabTitle: 'Labor - ' + submitModel.ItemNumber
                    }
                  }, false);
              }
            }, 300);
            this.DestroySubscriptions();
          }, error => {
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.showMultiLineError(error.error.Message, "Error");
          }
        )
      }
      else {
        this.laborItemService.SaveLaborItem(submitModel)
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe(
          response => {
            if ($(this._elementRef.nativeElement).find('.tabs__content__box').hasClass('dirty')) {
              $(this._elementRef.nativeElement).find('.tabs__content__box').removeClass('dirty');
            }
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.success("Labor item " + submitModel.ItemNumber + " created", "Success!");
            this.dataSharing.ItemChangeEvent();
            setTimeout(() => {
              if (this.destroyTab) {
                this.tabOpen.DestroyTab(this.tabCounter);
              }
              else {
                this.tabOpen.ReplaceTab(
                  {
                    CurrentTabIndex: this.tabCounter,
                    newTabInfo: {
                      tabId: Tabs.FsLiteLaborItemDetail,
                      params: { ID: response.ID },
                      tabTitle: 'Labor - ' + submitModel.ItemNumber
                    }
                  }, false);
              }
            }, 300);
            this.DestroySubscriptions();
          }, error => {
            this.destroyTab = false;
            this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
            this.toastr.showMultiLineError(error.error.Message, "Error");
          });
      }
    }
    else {
      this.commonMethods.markFormGroupTouched(this.createLaborItemForm);
      this.zone.runOutsideAngular(() => {
        customJS.verifyBoxes(this.$elementRef.nativeElement);
      });
      setTimeout(() => {
        this.destroyTab = false;
      }, 200)
    }
  }

  public CancelAction() {
    if (this.laborDetailData.ID != "") {
      this.tabOpen.ReplaceTab(
        {
          CurrentTabIndex: this.tabCounter,
          newTabInfo: {
            tabId: Tabs.FsLiteLaborItemDetail,
            params: { ID: this.laborDetailData.ID },
            tabTitle: 'Labor - ' + this.laborDetailData.ItemNumber
          }
        }, true);
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
    }
  }

  private GetTrades() {
    this.overlay = true;
    this.fSliteTradeService.fetch("", this.state, "")
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe(r => {
        this.categories = r.Children;
        setTimeout(() => {
          this.createLaborItemForm.controls["Category"].setValue(this.laborDetailData.Category.ID);
          this.overlay = false;
        }, 1000);
      }, () => {
        this.overlay = false;
      });
  }

  private CreatelabrItemForm() {
    if (this.laborDetailData == undefined || this.laborDetailData.ID == undefined)
      this.laborDetailData = new LaborItemModel();
  
    this.createLaborItemForm = this.frmbuilder.group({
      "ID": new FormControl(this.laborDetailData.ID),
      "ItemNumber": new FormControl(this.laborDetailData.ItemNumber, [this.commonMethods.noWhitespaceValidator, Validators.maxLength(50)]),
      "Description": new FormControl(this.laborDetailData.Description, [this.commonMethods.noWhitespaceValidator, Validators.maxLength(1024)]),
      "IsFrequentlyUsed": new FormControl(this.laborDetailData.IsFrequentlyUsed),
      "Category": new FormControl(this.laborDetailData.Category.length > 0 ? this.laborDetailData.Category.ID : "", Validators.required),
      "AccountingCode": new FormControl(this.laborDetailData.AccountingCode == null ? "" : this.laborDetailData.AccountingCode.ID),
      "Note": new FormControl(this.laborDetailData.Note, Validators.maxLength(1024)),
      "StandardCost": new FormControl(this.laborDetailData.Prices.length == 0 ? 0 : +this.laborDetailData.Prices[0].Amount, Validators.required),
      "Price": new FormControl(""),
      "Cost": new FormControl(+this.laborDetailData.Cost),
      "IsPriceEditAllowed": new FormControl(this.laborDetailData.IsPriceEditAllowed),
      "IsDescriptionEditAllowed": new FormControl(this.laborDetailData.IsDescriptionEditAllowed),
      "IsDiscountExcluded": new FormControl(this.laborDetailData.IsDiscountExcluded),
      "IsTaxable": new FormControl(this.laborDetailData.IsTaxable),
      "IsAgreementExcluded": new FormControl(this.laborDetailData.IsAgreementExcluded)
    });
  }

  private CheckAndReplace() {
    if (this.laborDetailData.ID != "") {
      this.tabOpen.ReplaceTab(
        {
          CurrentTabIndex: this.tabCounter,
          newTabInfo: {
            tabId: Tabs.FsLiteLaborItemDetail,
            params: { ID: this.laborDetailData.ID },
            tabTitle: 'Labor - ' + this.laborDetailData.ItemNumber
          }
        }, true);
    } else {
      this.tabOpen.DestroyTab(this.tabCounter);
      let info = this.tabOpen.TabInfo;
      this.tabOpen.OpenTab({
        tabId: Tabs.FsLitePriceBookList,
        params: {},
        tabTitle: 'Products'
      });
    }
  }

  private DestroySubscriptions() {
    this.subscriptions.forEach(element => {
      element.unsubscribe();
    });
  }

  private HideDataLoader() {
    this.dataLoaderCount = this.dataLoaderCount - 1;
    if (this.dataLoaderCount <= 0) {
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    }
  }

  private GetLaborItemDetail() {
    this.showspinner.showloader(this.viewContainerRef, this.tabCounter);
    this.laborItemService.GetLaborItem({ params: this.inputParams })
    .pipe(takeUntil(this.ngUnsubscribe$))
    .subscribe(response => {
      this.laborDetailData = response;
      this.formType = "Edit"
      this.HideDataLoader();
      this.CreatelabrItemForm();
    }, error => {
      this.toastr.showMultiLineError(error.error.Message, "Error");
      this.showspinner.hideLoader(this.viewContainerRef, this.tabCounter);
    });
  }
  //#endregion
}
